
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("4S5yk", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.AlertContainerWithoutStore = void 0;

var $38c083315a90ffa8$var$_react = $38c083315a90ffa8$var$_interopRequireWildcard((parcelRequire("7eprg")));


var $38c083315a90ffa8$var$_RemindersContainer = $l4FIw((parcelRequire("2uxrS")));

var $38c083315a90ffa8$var$types = $38c083315a90ffa8$var$_interopRequireWildcard((parcelRequire("je1Hc")));

var $38c083315a90ffa8$var$_PulseNotificationMessageWrapper = $l4FIw((parcelRequire("ljW5d")));

var $38c083315a90ffa8$var$_Card = $l4FIw((parcelRequire("gM7LE")));

var $ghWS5 = parcelRequire("ghWS5");
var $g7MWH = parcelRequire("g7MWH");

var $6oEXm = parcelRequire("6oEXm");

var $38c083315a90ffa8$var$localizationStrings = $38c083315a90ffa8$var$_interopRequireWildcard((parcelRequire("6UEx7")));

var $38c083315a90ffa8$var$_Provider = $l4FIw((parcelRequire("3a3O8")));

var $5hKOy = parcelRequire("5hKOy");

var $5IbNv = parcelRequire("5IbNv");

var $kh0TV = parcelRequire("kh0TV");

var $38c083315a90ffa8$var$_metrics = $l4FIw((parcelRequire("2uDvu")));

var $38c083315a90ffa8$var$_withRedux = $l4FIw((parcelRequire("5PuXn")));
function $38c083315a90ffa8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($38c083315a90ffa8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $38c083315a90ffa8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $38c083315a90ffa8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ const $38c083315a90ffa8$var$mapStateToProps = (state)=>({
        alerts: (0, $5IbNv.getNotificationAlerts)(state).map((entry)=>(0, $5IbNv.getNotificationById)(state, entry)),
        reminders: (0, $kh0TV.getActiveReminders)(state),
        serverTimeStamp: (0, $5IbNv.getServerTimestamp)(state),
        clientTimeStamp: (0, $5IbNv.getClientTimestamp)(state),
        locale: (0, $5IbNv.getLocale)(state),
        displayAlertsConfig: (0, $5IbNv.getDisplayAlertsConfig)(state)
    });
const $38c083315a90ffa8$var$mapDispatchToProps = (dispatch)=>({
        dispatchToMarkNotificationsAsShown: (ids)=>{
            dispatch({
                type: $38c083315a90ffa8$var$types.MARK_NOTIFICATIONS_AS_SHOWN,
                ids: ids
            });
        },
        dispatchToMarkAllRemindersAsShown: ()=>{
            dispatch({
                type: $38c083315a90ffa8$var$types.MARK_ALL_REMINDERS_AS_SHOWN
            });
        },
        dispatchToMarkReminderAsShown: async (id)=>{
            await dispatch({
                type: $38c083315a90ffa8$var$types.MARK_REMINDER_AS_SHOWN,
                ids: [
                    id
                ]
            });
        }
    });
const $38c083315a90ffa8$var$AlertsContainer = (props)=>{
    const { theme: theme = "lightest", alerts: alerts, reminders: reminders, serverTimeStamp: serverTimeStamp, clientTimeStamp: clientTimeStamp, locale: locale, displayAlertsConfig: displayAlertsConfig, dispatchToMarkNotificationsAsShown: dispatchToMarkNotificationsAsShown, dispatchToMarkAllRemindersAsShown: dispatchToMarkAllRemindersAsShown, dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown } = props;
    const metrics = (0, $38c083315a90ffa8$var$_metrics.default)("exc.pulse.components.alerts.AlertsContainer");
    (0, $38c083315a90ffa8$var$_react.useEffect)(()=>{
        if (alerts.length > 0) {
            if (!displayAlertsConfig.manualDismiss) {
                const floatingAlerTimeoutInMilliseconds = displayAlertsConfig.duration * 1000;
                setTimeout(()=>{
                    dispatchToMarkNotificationsAsShown(alerts.map((entry)=>entry.id));
                }, floatingAlerTimeoutInMilliseconds);
            }
        }
    }, [
        alerts
    ]);
    const onAllRemindersClosed = ()=>{
        metrics.event("all.reminders.close", {
            region: window.config && window.config.region
        });
        dispatchToMarkAllRemindersAsShown();
    };
    const onReminderClosed = async (id)=>{
        metrics.event("reminder.close", {
            region: window.config && window.config.region
        });
        await dispatchToMarkReminderAsShown(id);
    };
    return /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement("div", {
        className: "pulse-alerts-container"
    }, /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement($38c083315a90ffa8$var$_Provider.default, {
        className: "pulse-provider",
        theme: theme
    }, /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement("div", {
        className: "alerts-wrapper"
    }, reminders.length > 0 && /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement($ghWS5.default, {
        classNames: "alert",
        timeout: 500
    }, /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement($6oEXm.IntlProvider, {
        locale: locale,
        messages: $38c083315a90ffa8$var$localizationStrings
    }, /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement($38c083315a90ffa8$var$_RemindersContainer.default, {
        clientTimeStamp: clientTimeStamp,
        closeHandler: onAllRemindersClosed,
        onReminderClosed: onReminderClosed,
        reminders: reminders,
        serverTimeStamp: serverTimeStamp
    }))), /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement($g7MWH.default, null, alerts.map((entry, key)=>/*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement($ghWS5.default, {
            classNames: "pulse-alert",
            key: key,
            timeout: 500
        }, /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement("div", {
            style: {
                marginBottom: "1rem"
            }
        }, /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement($38c083315a90ffa8$var$_Card.default, null, /*#__PURE__*/ $38c083315a90ffa8$var$_react.default.createElement($38c083315a90ffa8$var$_PulseNotificationMessageWrapper.default, {
            clientTimeStamp: clientTimeStamp,
            isFloatingAlert: true,
            isReminder: false,
            locale: locale,
            pulseMessageObject: entry,
            renderCrossButton: false,
            serverTimeStamp: serverTimeStamp
        })))))))));
};
$38c083315a90ffa8$var$AlertsContainer.defaultProps = {
    locale: "en-US",
    localizationStrings: {
        DismissReminder: "Dismiss reminder",
        DismissAlert: "Dismiss",
        Snooze: "Remind me",
        DeleteReminder: "Delete reminder",
        EditReminder: "Edit reminder",
        SetReminder: "Reminder set for {formattedReminderTime}",
        RemindMeTomorrow: "Remind me tomorrow",
        RemindMe60Min: "Remind me in an hour",
        RemindMe15Min: "Remind me in 15 minutes",
        RemindMe5Min: "Remind me in 5 minutes",
        DismissAllReminders: "Dismiss all reminders",
        Reminder: "Reminder",
        Reminders: "Reminders"
    }
};
const $38c083315a90ffa8$var$AlertContainerWithoutStore = (0, $5hKOy.connect)($38c083315a90ffa8$var$mapStateToProps, $38c083315a90ffa8$var$mapDispatchToProps)($38c083315a90ffa8$var$AlertsContainer);
module.exports.AlertContainerWithoutStore = $38c083315a90ffa8$var$AlertContainerWithoutStore;
var $38c083315a90ffa8$var$_default = (0, $38c083315a90ffa8$var$_withRedux.default)($38c083315a90ffa8$var$AlertContainerWithoutStore);
module.exports.default = $38c083315a90ffa8$var$_default;

});
parcelRegister("2uxrS", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.RemindersContainer = void 0;

var $1d085452b1d2f5d4$var$_react = $l4FIw((parcelRequire("7eprg")));


var $1d085452b1d2f5d4$var$_CrossMedium = $l4FIw((parcelRequire("eJXsb")));

var $1d085452b1d2f5d4$var$_PulseNotificationMessageWrapper = $l4FIw((parcelRequire("ljW5d")));

var $ghWS5 = parcelRequire("ghWS5");
var $g7MWH = parcelRequire("g7MWH");

var $1d085452b1d2f5d4$var$_OverlayTrigger = $l4FIw((parcelRequire("aKT0j")));

var $1d085452b1d2f5d4$var$_Tooltip = $l4FIw((parcelRequire("72PXO")));

var $a6smq = parcelRequire("a6smq");

var $awzum = parcelRequire("awzum");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ const $1d085452b1d2f5d4$var$RemindersContainer = (props)=>{
    const { reminders: reminders, closeHandler: closeHandler, onReminderClosed: onReminderClosed, serverTimeStamp: serverTimeStamp, clientTimeStamp: clientTimeStamp, intl: intl } = props;
    const { formatMessage: formatMessage, locale: locale } = intl;
    return /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement("div", {
        className: "reminder-conatiner"
    }, /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement("div", {
        className: "reminder-header"
    }, reminders.length > 1 ? /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement("div", null, formatMessage({
        id: "Reminders",
        defaultMessage: "Reminders",
        description: "Reminders"
    }), ` (${reminders.length})`) : /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement("div", null, formatMessage({
        id: "Reminder",
        defaultMessage: "Reminder",
        description: "Reminder"
    })), /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement($1d085452b1d2f5d4$var$_OverlayTrigger.default, {
        delayShow: $awzum.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
        placement: "top",
        trigger: "hover"
    }, /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement("div", {
        className: "reminder-close",
        onClick: ()=>closeHandler(),
        role: "button",
        tabIndex: 0
    }, /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement($1d085452b1d2f5d4$var$_CrossMedium.default, {
        size: null
    })), /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement($1d085452b1d2f5d4$var$_Tooltip.default, null, reminders.length > 1 ? formatMessage({
        id: "DismissAllReminders",
        defaultMessage: "Dismiss all reminders",
        description: "Dismiss all reminders"
    }) : formatMessage({
        id: "DismissReminder",
        defaultMessage: "Dismiss reminder",
        description: "Dismiss reminder"
    })))), /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement("div", {
        className: "reminder-list"
    }, /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement($g7MWH.default, null, reminders.map((entry)=>{
        /*
        *as per design we need to show notification's read mode style for reminder
        *hence changing isRead to true
        */ entry.isRead = true;
        entry.fromReminder = true;
        return /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement($ghWS5.default, {
            classNames: "pulse-alert",
            key: entry.id,
            timeout: 500
        }, /*#__PURE__*/ $1d085452b1d2f5d4$var$_react.default.createElement($1d085452b1d2f5d4$var$_PulseNotificationMessageWrapper.default, {
            clientTimeStamp: clientTimeStamp,
            isFloatingAlert: false,
            isReminder: true,
            locale: locale,
            onMessageCloseClicked: ()=>onReminderClosed(entry.id),
            pulseMessageObject: entry,
            renderCrossButton: reminders.length > 1,
            serverTimeStamp: serverTimeStamp
        }));
    }))));
};
module.exports.RemindersContainer = $1d085452b1d2f5d4$var$RemindersContainer;
var $1d085452b1d2f5d4$var$_default = (0, $a6smq.default)($1d085452b1d2f5d4$var$RemindersContainer);
module.exports.default = $1d085452b1d2f5d4$var$_default;

});
parcelRegister("eJXsb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $32iuA = parcelRequire("32iuA");
var $abb362e62e8ed787$var$_Icon2 = $abb362e62e8ed787$var$_interopRequireDefault($32iuA);

var $7eprg = parcelRequire("7eprg");
var $abb362e62e8ed787$var$_react2 = $abb362e62e8ed787$var$_interopRequireDefault($7eprg);
function $abb362e62e8ed787$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $abb362e62e8ed787$var$WrappedIcon = function WrappedIcon(props) {
    return $abb362e62e8ed787$var$_react2.default.createElement($abb362e62e8ed787$var$_Icon2.default, props, $abb362e62e8ed787$var$_react2.default.createElement("svg", {
        className: "spectrum-UIIcon-CrossMedium"
    }, $abb362e62e8ed787$var$_react2.default.createElement("path", {
        d: "M7.77 6.709L5.061 4 7.77 1.291A.75.75 0 1 0 6.709.23L4 2.939 1.291.23A.75.75 0 1 0 .23 1.291L2.939 4 .23 6.709A.75.75 0 1 0 1.291 7.77L4 5.061 6.709 7.77A.75.75 0 1 0 7.77 6.709z",
        className: "spectrum-UIIcon--medium"
    }), $abb362e62e8ed787$var$_react2.default.createElement("path", {
        d: "M9.77 8.709L6.061 5 9.77 1.291A.75.75 0 1 0 8.709.23L5 3.939 1.291.23A.75.75 0 1 0 .23 1.291L3.939 5 .23 8.709A.75.75 0 1 0 1.291 9.77L5 6.061 8.709 9.77A.75.75 0 1 0 9.77 8.709z",
        className: "spectrum-UIIcon--large"
    })));
};
$abb362e62e8ed787$var$WrappedIcon.displayName = "CrossMedium";
module.exports.default = $abb362e62e8ed787$var$WrappedIcon;

});

parcelRegister("ghWS5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bdbbe67e428f56d1$export$2e2bcd8739ae039; });

var $fLJOt = parcelRequire("fLJOt");

var $7uTSd = parcelRequire("7uTSd");

var $ybTpo = parcelRequire("ybTpo");


var $5lz0Y = parcelRequire("5lz0Y");

var $egxOX = parcelRequire("egxOX");

var $7eprg = parcelRequire("7eprg");

var $aQDJL = parcelRequire("aQDJL");


var $8GmTN = parcelRequire("8GmTN");
var $bdbbe67e428f56d1$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $5lz0Y.default)(node, c);
    });
};
var $bdbbe67e428f56d1$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $egxOX.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $bdbbe67e428f56d1$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $ybTpo.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $8GmTN.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $bdbbe67e428f56d1$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $bdbbe67e428f56d1$var$removeClass(node, baseClassName);
        if (activeClassName) $bdbbe67e428f56d1$var$removeClass(node, activeClassName);
        if (doneClassName) $bdbbe67e428f56d1$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $7uTSd.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $aQDJL.default), (0, $fLJOt.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).Component);
$bdbbe67e428f56d1$var$CSSTransition.defaultProps = {
    classNames: ""
};
$bdbbe67e428f56d1$var$CSSTransition.propTypes = {};
var $bdbbe67e428f56d1$export$2e2bcd8739ae039 = $bdbbe67e428f56d1$var$CSSTransition;

});
parcelRegister("5lz0Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e4a1317043c92f0$export$2e2bcd8739ae039; });

var $iDCxM = parcelRequire("iDCxM");
function $3e4a1317043c92f0$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $iDCxM.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("iDCxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d919c480235eeb41$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $d919c480235eeb41$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("egxOX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a62ccb7117911d82$export$2e2bcd8739ae039; });
function $a62ccb7117911d82$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $a62ccb7117911d82$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $a62ccb7117911d82$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $a62ccb7117911d82$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});


parcelRegister("g7MWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bbd3446a384e21bd$export$2e2bcd8739ae039; });

var $7uTSd = parcelRequire("7uTSd");

var $fLJOt = parcelRequire("fLJOt");

var $01b32 = parcelRequire("01b32");

var $ybTpo = parcelRequire("ybTpo");


var $7eprg = parcelRequire("7eprg");

var $hiS7v = parcelRequire("hiS7v");

var $hP1AJ = parcelRequire("hP1AJ");
var $bbd3446a384e21bd$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $bbd3446a384e21bd$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $bbd3446a384e21bd$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $ybTpo.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $01b32.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $hP1AJ.getInitialChildMapping)(nextProps, handleExited) : (0, $hP1AJ.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $hP1AJ.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $fLJOt.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $7uTSd.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $bbd3446a384e21bd$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $hiS7v.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement((0, $hiS7v.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7eprg))).Component);
$bbd3446a384e21bd$var$TransitionGroup.propTypes = {};
$bbd3446a384e21bd$var$TransitionGroup.defaultProps = $bbd3446a384e21bd$var$defaultProps;
var $bbd3446a384e21bd$export$2e2bcd8739ae039 = $bbd3446a384e21bd$var$TransitionGroup;

});
parcelRegister("01b32", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0038aa012df4e404$export$2e2bcd8739ae039; });
function $0038aa012df4e404$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("hP1AJ", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $cf986f1e61d2db11$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $cf986f1e61d2db11$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $cf986f1e61d2db11$export$36fd1af28d383ec0; });

var $7eprg = parcelRequire("7eprg");
function $cf986f1e61d2db11$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7eprg.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7eprg.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $cf986f1e61d2db11$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $cf986f1e61d2db11$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $cf986f1e61d2db11$export$fa71e2345c31d7a2(props, onExited) {
    return $cf986f1e61d2db11$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7eprg.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $cf986f1e61d2db11$var$getProp(child, "appear", props),
            enter: $cf986f1e61d2db11$var$getProp(child, "enter", props),
            exit: $cf986f1e61d2db11$var$getProp(child, "exit", props)
        });
    });
}
function $cf986f1e61d2db11$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $cf986f1e61d2db11$export$bbc8a025727ea824(nextProps.children);
    var children = $cf986f1e61d2db11$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7eprg.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7eprg.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7eprg.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $cf986f1e61d2db11$var$getProp(child, "exit", nextProps),
            enter: $cf986f1e61d2db11$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7eprg.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7eprg.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7eprg.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $cf986f1e61d2db11$var$getProp(child, "exit", nextProps),
            enter: $cf986f1e61d2db11$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});



parcelRegister("6UEx7", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "de_DE", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_de_de.default;
    }
});
Object.defineProperty(module.exports, "en_US", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_en_us.default;
    }
});
Object.defineProperty(module.exports, "es_ES", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_es_es.default;
    }
});
Object.defineProperty(module.exports, "fr_FR", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_fr_fr.default;
    }
});
Object.defineProperty(module.exports, "it_IT", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_it_it.default;
    }
});
Object.defineProperty(module.exports, "ja_JP", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_ja_jp.default;
    }
});
Object.defineProperty(module.exports, "ko_KR", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_ko_kr.default;
    }
});
Object.defineProperty(module.exports, "pt_BR", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_pt_br.default;
    }
});
Object.defineProperty(module.exports, "zh_CN", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_zh_cn.default;
    }
});
Object.defineProperty(module.exports, "zh_TW", {
    enumerable: true,
    get: function() {
        return $50876a0f3a39b16c$var$_zh_tw.default;
    }
});

var $50876a0f3a39b16c$var$_en_us = $l4FIw((parcelRequire("h45ee")));

var $50876a0f3a39b16c$var$_ko_kr = $l4FIw((parcelRequire("1LEul")));

var $50876a0f3a39b16c$var$_zh_tw = $l4FIw((parcelRequire("gv6DH")));

var $50876a0f3a39b16c$var$_zh_cn = $l4FIw((parcelRequire("gh1pQ")));

var $50876a0f3a39b16c$var$_pt_br = $l4FIw((parcelRequire("2bZMc")));

var $50876a0f3a39b16c$var$_it_it = $l4FIw((parcelRequire("1Fz9j")));

var $50876a0f3a39b16c$var$_es_es = $l4FIw((parcelRequire("fx3qR")));

var $50876a0f3a39b16c$var$_ja_jp = $l4FIw((parcelRequire("blxNI")));

var $50876a0f3a39b16c$var$_de_de = $l4FIw((parcelRequire("gSCzK")));

var $50876a0f3a39b16c$var$_fr_fr = $l4FIw((parcelRequire("kIV01")));

});
parcelRegister("h45ee", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Delete reminder","DismissAlert":"Dismiss","DismissAllReminders":"Dismiss all reminders","DismissReminder":"Dismiss reminder","EditReminder":"Edit reminder","RemindMe15Min":"Remind me in 15 minutes","RemindMe5Min":"Remind me in 5 minutes","RemindMe60Min":"Remind me in an hour","RemindMeTomorrow":"Remind me tomorrow","Reminder":"Reminder","Reminders":"Reminders","SetReminder":"Reminder set for {formattedReminderTime}","Snooze":"Remind me"}');

});

parcelRegister("1LEul", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"\uBBF8\uB9AC \uC54C\uB9BC \uC0AD\uC81C","DismissAlert":"\uB2EB\uAE30","DismissAllReminders":"\uBAA8\uB4E0 \uBBF8\uB9AC \uC54C\uB9BC \uB2EB\uAE30","DismissReminder":"\uBBF8\uB9AC \uC54C\uB9BC \uB2EB\uAE30","EditReminder":"\uBBF8\uB9AC \uC54C\uB9BC \uD3B8\uC9D1","RemindMe15Min":"15\uBD84 \uD6C4\uC5D0 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMe5Min":"5\uBD84 \uD6C4\uC5D0 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMe60Min":"1\uC2DC\uAC04 \uD6C4\uC5D0 \uB2E4\uC2DC \uC54C\uB9AC\uAE30","RemindMeTomorrow":"\uB0B4\uC77C \uB2E4\uC2DC \uC54C\uB9AC\uAE30","Reminder":"\uBBF8\uB9AC \uC54C\uB9BC","Reminders":"\uBBF8\uB9AC \uC54C\uB9BC","SetReminder":"{formattedReminderTime}\uC5D0 \uC124\uC815\uB41C \uBBF8\uB9AC \uC54C\uB9BC","Snooze":"\uB2E4\uC2DC \uC54C\uB9AC\uAE30"}');

});

parcelRegister("gv6DH", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"\u522A\u9664\u63D0\u9192","DismissAlert":"\u95DC\u9589","DismissAllReminders":"\u95DC\u9589\u6240\u6709\u63D0\u9192","DismissReminder":"\u95DC\u9589\u63D0\u9192","EditReminder":"\u7DE8\u8F2F\u63D0\u9192","RemindMe15Min":"15 \u5206\u9418\u5F8C\u518D\u63D0\u9192\u6211","RemindMe5Min":"5 \u5206\u9418\u5F8C\u518D\u63D0\u9192\u6211","RemindMe60Min":"1 \u5C0F\u6642\u5F8C\u518D\u63D0\u9192\u6211","RemindMeTomorrow":"\u660E\u5929\u518D\u63D0\u9192\u6211","Reminder":"\u63D0\u9192","Reminders":"\u63D0\u9192","SetReminder":"\u5DF2\u8A2D\u5B9A\u63D0\u9192\u6642\u9593: {formattedReminderTime}","Snooze":"\u63D0\u9192\u6211"}');

});

parcelRegister("gh1pQ", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"\u5220\u9664\u63D0\u9192","DismissAlert":"\u53D6\u6D88","DismissAllReminders":"\u53D6\u6D88\u6240\u6709\u63D0\u9192","DismissReminder":"\u53D6\u6D88\u63D0\u9192","EditReminder":"\u7F16\u8F91\u63D0\u9192","RemindMe15Min":"15 \u5206\u949F\u540E\u63D0\u9192\u6211","RemindMe5Min":"5 \u5206\u949F\u540E\u63D0\u9192\u6211","RemindMe60Min":"1 \u5C0F\u65F6\u540E\u63D0\u9192\u6211","RemindMeTomorrow":"\u660E\u5929\u63D0\u9192\u6211","Reminder":"\u63D0\u9192","Reminders":"\u63D0\u9192","SetReminder":"\u63D0\u9192\u65F6\u95F4\u4E3A\uFF1A{formattedReminderTime}","Snooze":"\u63D0\u9192\u6211"}');

});

parcelRegister("2bZMc", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Excluir lembrete","DismissAlert":"Ignorar","DismissAllReminders":"Ignorar todos os lembretes","DismissReminder":"Ignorar lembrete","EditReminder":"Editar lembrete","RemindMe15Min":"Lembrar em 15 minutos","RemindMe5Min":"Lembrar em 5 minutos","RemindMe60Min":"Lembrar em uma hora","RemindMeTomorrow":"Lembre-me amanh\xe3","Reminder":"Lembrete","Reminders":"Lembretes","SetReminder":"Lembrete definido para {formattedReminderTime}","Snooze":"Lembre-me"}');

});

parcelRegister("1Fz9j", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Elimina promemoria","DismissAlert":"Ignora","DismissAllReminders":"Ignora tutti i promemoria","DismissReminder":"Ignora promemoria","EditReminder":"Modifica promemoria","RemindMe15Min":"Ricordami tra 15 minuti","RemindMe5Min":"Ricordami tra 5 minuti","RemindMe60Min":"Ricordami tra 1 ora","RemindMeTomorrow":"Ricordami domani","Reminder":"Promemoria","Reminders":"Promemoria","SetReminder":"Promemoria impostato per {formattedReminderTime}","Snooze":"Attiva promemoria"}');

});

parcelRegister("fx3qR", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Borrar recordatorio","DismissAlert":"Descartar","DismissAllReminders":"Descartar todos los recordatorios","DismissReminder":"Descartar recordatorio","EditReminder":"Editar recordatorio","RemindMe15Min":"Recordatorio en 15 minutos","RemindMe5Min":"Recordatorio en 5 minutos","RemindMe60Min":"Recordatorio en una hora","RemindMeTomorrow":"Recordatorio ma\xf1ana","Reminder":"Recordatorio","Reminders":"Recordatorios","SetReminder":"Recordatorio establecido para {formattedReminderTime}","Snooze":"Recordarme"}');

});

parcelRegister("blxNI", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u524A\u9664","DismissAlert":"\u4E86\u89E3","DismissAllReminders":"\u3059\u3079\u3066\u306E\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u89E3\u9664","DismissReminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u89E3\u9664","EditReminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u3092\u7DE8\u96C6","RemindMe15Min":"15 \u5206\u5F8C\u306B\u901A\u77E5","RemindMe5Min":"5 \u5206\u5F8C\u306B\u901A\u77E5","RemindMe60Min":"1 \u6642\u9593\u5F8C\u306B\u901A\u77E5","RemindMeTomorrow":"\u660E\u65E5\u901A\u77E5","Reminder":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC","Reminders":"\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC","SetReminder":"{formattedReminderTime} \u306E\u30EA\u30DE\u30A4\u30F3\u30C0\u30FC\u8A2D\u5B9A","Snooze":"\u5F8C\u3067\u901A\u77E5\u3059\u308B"}');

});

parcelRegister("gSCzK", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Erinnerung l\xf6schen","DismissAlert":"Verwerfen","DismissAllReminders":"Alle Erinnerungen verwerfen","DismissReminder":"Erinnerung verwerfen","EditReminder":"Erinnerung bearbeiten","RemindMe15Min":"Erinnere mich in 15 Minuten","RemindMe5Min":"Erinnere mich in 5 Minuten","RemindMe60Min":"Erinnere mich in einer Stunde","RemindMeTomorrow":"Erinnere mich morgen","Reminder":"Erinnerung","Reminders":"Erinnerungen","SetReminder":"Erinnerung eingerichtet f\xfcr {formattedReminderTime}","Snooze":"Erinnern"}');

});

parcelRegister("kIV01", function(module, exports) {
module.exports = JSON.parse('{"DeleteReminder":"Supprimer le rappel","DismissAlert":"Ignorer","DismissAllReminders":"Rejeter tous les rappels","DismissReminder":"Rejeter le rappel","EditReminder":"Modifier le rappel","RemindMe15Min":"Me le rappeler dans 15\xa0minutes","RemindMe5Min":"Me le rappeler dans 5\xa0minutes","RemindMe60Min":"Me le rappeler dans une heure","RemindMeTomorrow":"Me le rappeler demain","Reminder":"Rappel","Reminders":"Rappels","SetReminder":"Rappel d\xe9fini pour {formattedReminderTime}","Snooze":"Me le rappeler"}');

});


parcelRegister("5PuXn", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43e9ba83f7ccd507$var$_react = $l4FIw((parcelRequire("7eprg")));

var $5hKOy = parcelRequire("5hKOy");

var $43e9ba83f7ccd507$var$_store = $l4FIw((parcelRequire("59XPv")));
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/ /**
 * This HOC wraps store around the Container component.
 * @param WrappedComponent
 */ const $43e9ba83f7ccd507$var$withRedux = (WrappedComponent)=>{
    class WithRedux extends $43e9ba83f7ccd507$var$_react.default.PureComponent {
        constructor(props){
            super(props);
        }
        render() {
            return /*#__PURE__*/ $43e9ba83f7ccd507$var$_react.default.createElement("div", null, /*#__PURE__*/ $43e9ba83f7ccd507$var$_react.default.createElement($5hKOy.Provider, {
                store: $43e9ba83f7ccd507$var$_store.default
            }, /*#__PURE__*/ $43e9ba83f7ccd507$var$_react.default.createElement(WrappedComponent, this.props)));
        }
    }
    return WithRedux;
};
var $43e9ba83f7ccd507$var$_default = $43e9ba83f7ccd507$var$withRedux;
module.exports.default = $43e9ba83f7ccd507$var$_default;

});


parcelRegister("bXuNV", function(module, exports) {

var $MtdVr = parcelRequire("MtdVr");
/** Built-in value references. */ var $8b4d1976eecc9a0e$var$Symbol = $MtdVr.Symbol;
module.exports = $8b4d1976eecc9a0e$var$Symbol;

});
parcelRegister("MtdVr", function(module, exports) {

var $j3D3B = parcelRequire("j3D3B");
/** Detect free variable `self`. */ var $091b270227316647$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $091b270227316647$var$root = $j3D3B || $091b270227316647$var$freeSelf || Function("return this")();
module.exports = $091b270227316647$var$root;

});
parcelRegister("j3D3B", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ddfc980967925035$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ddfc980967925035$var$freeGlobal;

});



parcelRegister("aSp3t", function(module, exports) {

var $bXuNV = parcelRequire("bXuNV");

var $jb2qm = parcelRequire("jb2qm");

var $i3rnS = parcelRequire("i3rnS");
/** `Object#toString` result references. */ var $7eb261ef8f9d8f0f$var$nullTag = "[object Null]", $7eb261ef8f9d8f0f$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $7eb261ef8f9d8f0f$var$symToStringTag = $bXuNV ? $bXuNV.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $7eb261ef8f9d8f0f$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $7eb261ef8f9d8f0f$var$undefinedTag : $7eb261ef8f9d8f0f$var$nullTag;
    return $7eb261ef8f9d8f0f$var$symToStringTag && $7eb261ef8f9d8f0f$var$symToStringTag in Object(value) ? $jb2qm(value) : $i3rnS(value);
}
module.exports = $7eb261ef8f9d8f0f$var$baseGetTag;

});
parcelRegister("jb2qm", function(module, exports) {

var $bXuNV = parcelRequire("bXuNV");
/** Used for built-in method references. */ var $df60eccb65f46f89$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $df60eccb65f46f89$var$hasOwnProperty = $df60eccb65f46f89$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $df60eccb65f46f89$var$nativeObjectToString = $df60eccb65f46f89$var$objectProto.toString;
/** Built-in value references. */ var $df60eccb65f46f89$var$symToStringTag = $bXuNV ? $bXuNV.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $df60eccb65f46f89$var$getRawTag(value) {
    var isOwn = $df60eccb65f46f89$var$hasOwnProperty.call(value, $df60eccb65f46f89$var$symToStringTag), tag = value[$df60eccb65f46f89$var$symToStringTag];
    try {
        value[$df60eccb65f46f89$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $df60eccb65f46f89$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$df60eccb65f46f89$var$symToStringTag] = tag;
        else delete value[$df60eccb65f46f89$var$symToStringTag];
    }
    return result;
}
module.exports = $df60eccb65f46f89$var$getRawTag;

});

parcelRegister("i3rnS", function(module, exports) {
/** Used for built-in method references. */ var $d24dbfb3555f09ce$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d24dbfb3555f09ce$var$nativeObjectToString = $d24dbfb3555f09ce$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d24dbfb3555f09ce$var$objectToString(value) {
    return $d24dbfb3555f09ce$var$nativeObjectToString.call(value);
}
module.exports = $d24dbfb3555f09ce$var$objectToString;

});


parcelRegister("3mKAi", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $27378fdd31f1f25a$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $27378fdd31f1f25a$var$isObjectLike;

});

parcelRegister("9qn6F", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6dc8773bbe68a9b9$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $6dc8773bbe68a9b9$var$isObject;

});

parcelRegister("fMk9i", function(module, exports) {

var $aSp3t = parcelRequire("aSp3t");

var $3mKAi = parcelRequire("3mKAi");
/** `Object#toString` result references. */ var $b7caf7dbbc21197e$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7caf7dbbc21197e$var$isSymbol(value) {
    return typeof value == "symbol" || $3mKAi(value) && $aSp3t(value) == $b7caf7dbbc21197e$var$symbolTag;
}
module.exports = $b7caf7dbbc21197e$var$isSymbol;

});

parcelRegister("aqdbz", function(module, exports) {

var $Stcqx = parcelRequire("Stcqx");

var $9qn6F = parcelRequire("9qn6F");

var $fMk9i = parcelRequire("fMk9i");
/** Used as references for various `Number` constants. */ var $79668f786815e8e5$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $79668f786815e8e5$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $79668f786815e8e5$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $79668f786815e8e5$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $79668f786815e8e5$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $79668f786815e8e5$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($fMk9i(value)) return $79668f786815e8e5$var$NAN;
    if ($9qn6F(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $9qn6F(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $Stcqx(value);
    var isBinary = $79668f786815e8e5$var$reIsBinary.test(value);
    return isBinary || $79668f786815e8e5$var$reIsOctal.test(value) ? $79668f786815e8e5$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $79668f786815e8e5$var$reIsBadHex.test(value) ? $79668f786815e8e5$var$NAN : +value;
}
module.exports = $79668f786815e8e5$var$toNumber;

});
parcelRegister("Stcqx", function(module, exports) {

var $icWez = parcelRequire("icWez");
/** Used to match leading whitespace. */ var $0a3bb1a9181fc9ac$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0a3bb1a9181fc9ac$var$baseTrim(string) {
    return string ? string.slice(0, $icWez(string) + 1).replace($0a3bb1a9181fc9ac$var$reTrimStart, "") : string;
}
module.exports = $0a3bb1a9181fc9ac$var$baseTrim;

});
parcelRegister("icWez", function(module, exports) {
/** Used to match a single whitespace character. */ var $d416850c9766e273$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d416850c9766e273$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d416850c9766e273$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $d416850c9766e273$var$trimmedEndIndex;

});



parcelRegister("8GCxQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6530253353490479$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $32iuA = parcelRequire("32iuA");
var $6530253353490479$var$_Icon2 = $6530253353490479$var$_interopRequireDefault($32iuA);

var $7eprg = parcelRequire("7eprg");
var $6530253353490479$var$_react2 = $6530253353490479$var$_interopRequireDefault($7eprg);
function $6530253353490479$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $6530253353490479$var$WrappedIcon = function WrappedIcon(props) {
    return $6530253353490479$var$_react2.default.createElement($6530253353490479$var$_Icon2.default, $6530253353490479$var$_extends({}, props, {
        icon: {
            18: (parcelRequire("dT0CN")),
            24: (parcelRequire("6OddY"))
        }
    }));
};
$6530253353490479$var$WrappedIcon.displayName = "Close";
module.exports.default = $6530253353490479$var$WrappedIcon;

});
parcelRegister("dT0CN", function(module, exports) {
"use strict";

var $7eprg = parcelRequire("7eprg");
module.exports = $7eprg.createElement("svg", {
    viewBox: "0 0 36 36"
}, $7eprg.createElement("path", {
    d: "M26.485 6.686L18 15.172 9.515 6.686a1 1 0 0 0-1.414 0L6.686 8.1a1 1 0 0 0 0 1.414L15.172 18l-8.486 8.485a1 1 0 0 0 0 1.414L8.1 29.314a1 1 0 0 0 1.414 0L18 20.828l8.485 8.485a1 1 0 0 0 1.414 0l1.415-1.413a1 1 0 0 0 0-1.414L20.828 18l8.485-8.485a1 1 0 0 0 0-1.414L27.9 6.686a1 1 0 0 0-1.415 0z"
}));

});

parcelRegister("6OddY", function(module, exports) {
"use strict";

var $7eprg = parcelRequire("7eprg");
module.exports = $7eprg.createElement("svg", {
    viewBox: "0 0 48 48"
}, $7eprg.createElement("path", {
    d: "M35.314 8.444L24 19.757 12.686 8.444a1 1 0 0 0-1.414 0l-2.828 2.828a1 1 0 0 0 0 1.414L19.757 24 8.444 35.314a1 1 0 0 0 0 1.414l2.828 2.828a1 1 0 0 0 1.414 0L24 28.243l11.314 11.313a1 1 0 0 0 1.414 0l2.828-2.828a1 1 0 0 0 0-1.414L28.243 24l11.313-11.314a1 1 0 0 0 0-1.414l-2.828-2.828a1 1 0 0 0-1.414 0z"
}));

});



//# sourceMappingURL=AlertsContainer.ad860cee.js.map
